<template>
	<div class="project-zaijian">
		<div class="title">
			<span>在建项目</span>
		</div>
		<el-divider></el-divider>
		<div class="projectList">
			<div v-for="item in plist" class="project" @click="openDetails(item)">
				<img src='/file/sss.png' draggable="false"></img>
				<div class="name">{{item.name}}</div>
				<div class="viewCount"><i class="el-icon-view"></i> {{item.viewCount}}</div>
			</div>
		</div>
	</div>
</template>

<script>
	import projectList from '@/assets/project.js'
	export default {
		data() {
			return {
				plist: []
			}
		},
		created() {

			this.plist = projectList.zaijian

			let id = this.$route.query.id
			if (id) {
				this.plist.map(item => {
					if (item.id == id) {
						this.openDetails(item)
					}
				})
			}

		},
		methods: {
			openDetails(val) {
				return false
				this.$emit('open_details', val)
			}
		}
	}
</script>

<style lang="scss">
	.project-zaijian {

		.title {
			line-height: 50px;
			font-weight: bold;
		}

		.el-divider {
			margin: 0;
			margin-bottom: 20px;
		}

		.projectList {
			.project {
				margin: 10px 16px 60px 16px;
				width: 320px;
				height: 180px;
				float: left;
				color: #000;
				cursor: pointer;

				img {
					border-radius: 8px;
					width: 100%;
					height: 100%;
				}

				.name {

					background-color: #F3EFEC;
					// background: -webkit-linear-gradient(top, #87878711, #35353566, #00000066);
					opacity: 0.99;
					font-size: 16px;
					text-align: left;
					height: 55px;
					line-height: 55px;
					margin-top: -10px;
					padding-left: 10px;
					border-bottom-right-radius: 8px;
					border-bottom-left-radius: 8px;
				}

				.viewCount {
					opacity: 0.99;
					height: 55px;
					line-height: 55px;
					margin-top: -55px;
					margin-right: 10px;
					text-align: right;

					i {
						font-weight: bold;
					}
				}
			}


			.project:hover {
				color: #fff;
				transform: scale(1.06);
				transition: 0.3s;

				.name {
					background-color: #7D3811;
				}
			}
		}
	}
</style>